module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/general-fb9af5b1abc67b954d7069361dc86b23.jpg";